import FileImportStatus from './FileImportStatus.gql';

export default FileImportStatus;
